import { render, staticRenderFns } from "./ETextarea.vue?vue&type=template&id=2409e36a&scoped=true&"
import script from "./ETextarea.vue?vue&type=script&lang=js&"
export * from "./ETextarea.vue?vue&type=script&lang=js&"
import style0 from "./ETextarea.vue?vue&type=style&index=0&id=2409e36a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2409e36a",
  null
  
)

export default component.exports